<template>
  <div>
    <!-- 添加地区表对话框 -->
    <el-dialog
        title="添加地区表"
        :visible.sync="addDialogVisible"
        width="60%"
        append-to-body
        @close="addDialogClosed"
    >
      <el-form
          ref="addFormRef"
          :model="addForm"
          :rules="rules"
          label-width="80px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="父级区划" prop="pid">
              <el-select v-model='addForm.pid' placeholder="请选择父级区划(一级不需要)">
                <el-option
                  v-for="item in oneLevelAreaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input v-model="addForm.name" placeholder="请输入名称"/>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="日语名称" prop="japan">
                <el-input v-model="addForm.japan" placeholder="请输入日语"/>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="地址简称" prop="shortName">
                <el-input v-model="addForm.shortName" placeholder="请输入简称"/>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="经度" prop="lng">
                <el-input v-model="addForm.lng" placeholder="请输入经度"/>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="纬度" prop="lat">
                <el-input v-model="addForm.lat" placeholder="请输入纬度"/>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model="addForm.sort" placeholder="请输入排序"/>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="级别" prop="level">
                <el-select v-model='addForm.level' placeholder="请选择级别">
                  <el-option
                    v-for="item in enumAreaLevel"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="热门城市" prop="enumHot">
                <el-select v-model='addForm.enumHot' placeholder="请选择级别">
                  <el-option
                    v-for="item in payYesNo"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addArea">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addArea} from "@/api/area/area";
import {getData} from "@/utils/code";
import { enumAreaLevel, payYesNo } from '@/js/enum'

export default {
  name: "addArea",
  data() {
    return {
      enumAreaLevel: enumAreaLevel,
      addForm: {}, //添加组织表单
      addDialogVisible: false,
      // 规则
      rules: {
            name: [{required: true, message: "名称不能为空", trigger: "blur"}],
            shortName: [{required: true, message: "简称不能为空", trigger: "blur"}],
            lng: [{required: true, message: "经度不能为空", trigger: "blur"}],
            lat: [{required: true, message: "纬度不能为空", trigger: "blur"}],
            sort: [{required: true, message: "排序不能为空", trigger: "blur"}],
            level: [{required: true, message: "级别不能为空", trigger: "blur"}],
            enumHot: [{required: true, message: "热门城市不能为空", trigger: "blur"}],
      },
      oneLevelAreaList: [],
      payYesNo: payYesNo
    }
  },
  watch:{
    oneLevelAreaList:{
      handler(val){
        this.oneLevelAreaList = val
      },
      deep:true
    }
  },
  methods: {
    cancel() {
      this.addDialogVisible = false
      this.addForm = {}
    },
    addDialog(oneLevelAreaList) {
      this.oneLevelAreaList = oneLevelAreaList
      this.addDialogVisible = true
    },
    // 监听添加对话框的关闭事件，重置表单
    addDialogClosed() {
      this.addForm = {}
    },
    // 添加
    addArea() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        addArea(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.addDialogVisible = false;
          }
        })
      });
    },

  }
}
</script>

<style scoped>

</style>
